import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { GlobalsService } from '../../../core/services/globals.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SKIP_ERROR_TOAST } from './skip-error-toast.token';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  const toastr = inject(ToastrService);
  const globalService = inject(GlobalsService);
  const router = inject(Router);
  const translate = inject(TranslateService);

  const authToken = isBrowser ? sessionStorage.getItem('auth-token') : null;

  const authReq = authToken
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`,
          'Accept-Language': translate.currentLang || 'pt-br',
        },
      })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      const skipToast = authReq.context.get(SKIP_ERROR_TOAST) === true;

      let errorMessage = translate.instant('ERRORS.UNKNOWN');

      if (error.status === 401) {
        errorMessage = translate.instant('ERRORS.401');
        sessionStorage.clear();
        router.navigate(['/login']);
      } else if (error.error?.message) {
        errorMessage = error.error.message;
      } else if (error.status) {
        const statusText =
          error.statusText && error.statusText !== 'OK'
            ? error.statusText
            : error?.error?.detail;

        const translated = translate.instant(`ERRORS.${error.status}`);
        errorMessage =
          translated !== `ERRORS.${error.status}`
            ? translated
            : translate.instant('ERRORS.DEFAULT', {
                status: error.status,
                statusText: statusText || '',
              });
      }

      if (!skipToast && isBrowser) toastr.error(errorMessage);

      return throwError(() => error);
    })
  );
};
